module.exports = __webpack_public_path__ + "static/media/downArrow.2e4955ac.svg";